export default __webpack_public_path__ + "static/pic_assistant-a917359158bc76ecf8bd7ea2121cf231.svg";